export default __webpack_public_path__ + "static/media/avatar-3.3c18ae78.png";